import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [menuAbierto, setMenuAbierto] = useState(false);

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  const cerrarMenu = () => {
    setMenuAbierto(false);
  };

  return (
    <header className="header">
      {/* Logo alineado a la izquierda */}
      <div className="logo">
        <span className="logo-stem">STEM</span>
        <span className="logo-sub">INSTITUTO MÉXICO</span>
      </div>

      {/* Botón menú hamburguesa para móvil */}
      <button className="menu-toggle" onClick={toggleMenu}>
        ☰
      </button>

      {/* Contenedor del menú */}
      <div className="nav-wrapper">
        <nav className={`nav ${menuAbierto ? 'activo' : ''}`}>

          <a href="#inicio" onClick={cerrarMenu}>Inicio</a>
          <a href="#nosotros" onClick={cerrarMenu}>Nosotros</a>

          {/* Dropdown Servicios */}
          <div className="dropdown">
            <span className="dropbtn">Servicios ▾</span>
            <div className="dropdown-content">
              <a href="#servicios-cursos" onClick={cerrarMenu}>
                Cursos y Programas de Capacitación
              </a>
              <a href="#servicios-materiales" onClick={cerrarMenu}>
                Desarrollo de Materiales Profesionales
              </a>
              <a href="#servicios-consultorias" onClick={cerrarMenu}>
                Consultorías Especializadas
              </a>
            </div>
          </div>

          <a href="#contacto" onClick={cerrarMenu}>Contacto</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;

